import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Role } from '../../../models/enums';
import { AuthService } from '../../auth/auth.service';

/** Poste de développement (serveur local). */
export const isLocalHost = (): boolean => {
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
};

/** Administrateur Mokah+ : rôle WA_ADMIN, chargé avec l'organisation Web-atrio active. */
export const isMokahAdmin = (auth: AuthService): boolean => auth.hasRole([Role.WaAdmin]) && auth.isWA();

/**
 * Hub Développeur (`/developpeur`, MOKA-305) : tout le monde sur un poste local ; sur un domaine
 * déployé (dev, prod), les Administrateurs Mokah+ seulement. La documentation est en plus
 * protégée côté base (bucket privé `developer-docs`, lecture WA_ADMIN) : ce garde n'est qu'une porte.
 */
export const developerHubGuard: CanActivateFn = () => {
  if (isLocalHost() || isMokahAdmin(inject(AuthService))) return true;
  return inject(Router).parseUrl('/404');
};
